<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(() => {
  const addSizingLinkToEasify = () => {
    document.querySelectorAll('.productView-product').forEach((product) => {
      const easify = product.querySelector('.easify-product-options');
      const labelRow = easify?.querySelector('.po-label-root');
      const originalLink = product.querySelector(
        '.productView-moreItem [data-open-size-chart-popup]'
      );

      if (!labelRow || !originalLink) return;

      originalLink
        .closest('.productView-moreItem')
        ?.classList.add('yr-size-guide-source');

      labelRow.classList.add('yr-sizing-label-row');

      if (labelRow.querySelector('.yr-sizing-label-link')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'yr-sizing-label-link';
      button.textContent = 'Measure & Sizing';

      button.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();

  originalLink.click();

  document.body.classList.add('size-chart-show');

  document
    .querySelector('.halo-size-chart-popup')
    ?.classList.add('is-show');
});

      labelRow.appendChild(button);
    });
  };

  const start = () => {
    addSizingLinkToEasify();

    new MutationObserver(addSizingLinkToEasify).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      'shopify:section:load',
      addSizingLinkToEasify
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* Judge.me 星级移动到价格右侧 */
(() => {
  const moveJudgeMeNextToPrice = () => {
    document
      .querySelectorAll(
        '.template-product .productView-details .productView-product'
      )
      .forEach((product) => {
        const price = product.querySelector('.productView-price');
        const priceRow = price?.closest('.productView-moreItem');

        const ratingBadge = product.querySelector('.jdgm-preview-badge');
        const ratingBlock =
          ratingBadge?.closest('.shopify-app-block') || ratingBadge;

        if (!priceRow || !ratingBlock) return;

        priceRow.classList.add('yr-price-rating-row');
        ratingBlock.classList.add('yr-price-rating');

        /* 移动原节点，保留 Judge.me 点击功能 */
        if (ratingBlock.parentElement !== priceRow) {
          priceRow.appendChild(ratingBlock);
        }
      });
  };

  let animationFrame;

  const scheduleMove = () => {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(moveJudgeMeNextToPrice);
  };

  const start = () => {
    moveJudgeMeNextToPrice();

    const observer = new MutationObserver(scheduleMove);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      'shopify:section:load',
      moveJudgeMeNextToPrice
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();

(() => {
  if (window.__yrCartDrawerFix) return;
  window.__yrCartDrawerFix = true;

  document.addEventListener('click', function (event) {
    const element = event.target instanceof Element ? event.target : null;
    const cartButton = element
      ? element.closest('[data-cart-sidebar]')
      : null;

    if (!cartButton) return;

    event.preventDefault();
    event.stopPropagation();

    if (document.body.classList.contains('template-cart')) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    document.body.classList.add('cart-sidebar-show');

    if (
      window.Shopify &&
      typeof window.Shopify.getCart === 'function' &&
      window.halo &&
      typeof window.halo.updateSidebarCart === 'function'
    ) {
      window.Shopify.getCart(function (cart) {
        window.halo.updateSidebarCart(cart);
      });
    }
  });
})();